<template>
  <layout>
    <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
    <div slot="content">
      <div class="btn-type1">
        <button class="btn-size btn-gray" @click="goSearch(true)"><span class="btn-icon"><i class="fas fa-search"></i></span> 조회</button>
      </div>

      <div class="pop-content-search">
        <div class="field has-addons ">
          <div class="control is-expanded search-area">
            <div class="ip-box rs-mt2">
              <span class="NotoM" style="margin-right: 10px;">- 모델 코드</span>
              <input class="input" type="text" v-model="form.modelCode" @keypress.enter="goSearch" style="padding-right:20px; width: 300px;">
            </div>
          </div>
          <div class="control is-expanded search-area">
            <div class="ip-box rs-mt2">
              <span class="NotoM" style="margin-right: 10px;">- 품명규격</span>
              <input class="input" type="text" v-model="form.descript" @keypress.enter="goSearch" style="padding-right:20px; width: 300px;">
            </div>
          </div>
        </div>
      </div>
      <div class="grid-wrap">
        <ag-grid-vue 
          style="width: 100%; height: 500px;"
          class="ag-theme-alpine"    
          row-selection="single"
                  
          :column-defs="columnDefs"     
          :grid-options="gridOptions"
          :row-data="rowData"
          :default-col-def="defaultColDef"
          @rowDoubleClicked="rowDoubleClick"
          @cell-clicked="onCellClicked"
          @grid-ready="onGridReady"/>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@/components/Slot/ModalSlot2.vue'
import mixin from '@/mixin';
import {AgGridVue} from 'ag-grid-vue';

export default {
  name: 'Vendor',
  components: {
    Layout,
    AgGridVue
  },
  mixins: [ mixin ],
  /* eslint-disable */
  props: ['param'],
  data() {
    return {
      title: '모델 재고 조회',
      form: {     
         modelCode: '',
         descript: ''
      },  
      rowData:[],
      gridOptions: {},
      columnDefs:[
        {
          headerName:'No.', 
          field:'no', 
          width:80,
          valueFormatter: function(params) {               
            return params.node.rowIndex+1;
          }
        },
        {
          headerName: '제품유형', 
          field:'jpryuCode', 
          width: 110, 
          cellStyle:{textAlign:'center'}
        },
        // {
        //   headerName: '제품유형', 
        //   field:'jpryuNm', 
        //   width: 120,
        //   cellStyle:{textAlign:'left'}
        // },
        {
          headerName: '모델코드', 
          field:'modelCode', 
          width: 200,
          cellStyle:{textAlign:'left'},
          // sort: 'asc',
          // sortIndex: 1
        },        
        {
          headerName: '납선', 
          field:'tradeCode', 
          width: 80,
          cellStyle:{textAlign:'center'}
        },                
        {
          headerName: '등급', 
          field:'gradeCode', 
          width: 80,
          cellStyle:{textAlign:'center'}
        },                 
        {
          headerName: '품명규격', 
          field:'descript', 
          width: 420,
          cellStyle:{textAlign:'left'}
        },                 
        {
          headerName: '재고', 
          field:'jaegoQty', 
          width: 110,
          cellStyle:{textAlign:'right'},
          // sort: 'desc',
          // sortIndex: 0
        },
        {
          field:'orderQty', 
          hide: true,
          editable: false
        },
        {
          field: 'jaegoYn',
          hide: true,
          editable: false,
          valueFormatter: (params) => {
            return params.data.jaegoQty > 0 ;
          }
        }
      ],
      defaultColDef: { 
        resizable: true, 
        filter:true, 
        sortable: true 
      }
    }
  },
  mounted() {
    if(this.param !== undefined) this.form.modelCode = this.param;
    if(this.form.modelCode) this.goSearch();
  },
  methods: {
    create(){
    },
    goSearch(slow) {
      if(!this.form.modelCode && !this.form.descript){
        
        this.$swal({ type: 'warning', text: '조회조건을 입력해 주시기 바랍니다.' })
      
      }else{
        var defaultSortModel = [
          { colId: 'jaegoQty', sort: 'desc', sortIndex: 0 },
          { colId: 'modelCode', sort: 'asc', sortIndex: 1 },
        ];
        this.gridOptions.columnApi.applyColumnState({ state: defaultSortModel });

        this.$store.commit('loading');
        this.$http
          .post("/api/common/model/jaego", {
            modelCode: this.form.modelCode,
            descript: this.form.descript,
          })        
          .then((result) => {
            this.rowData = result.data.map(x => {
              x.orderQty = 0;
              x.jaegoYn = x.jaegoQty > 0 ;
              return x;
            })
          })
          .catch(response => {
            console.error("Cctr_Ag Error");
          })
          .finally(() => {
            this.$store.commit('finish')
          });

      }
    },
    rowDoubleClick(params){
      this.$emit('close', params.data);
    },
    onCellClicked(params) {
      if(this.$store.state.isMobile) {
        this.$swal({
          type: 'info',
          text: `선택한 행을 선택 하시겠습니까?`,
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오',
        }).then((result) => {
          if (result.value) {
            this.$emit('close', params.data);
          }
        });
      }
    },
    closeModal() {
      this.$parent.close();
    },
    onGridReady(){
      //this.gridOptions.api.sizeColumnsToFit();
    }
  },
};
</script>

<style scoped>
/* .gridbox{height: 258px!important;}
.gridbox .objbox{height:185px!important;} */

</style>
